import React from "react";
import { useNavigate } from "react-router-dom";
import ReportProblemIcon from "@mui/icons-material/ReportProblem";
import { TbReport } from "react-icons/tb";
import { GrSchedulePlay } from "react-icons/gr";
import { FaMapMarkedAlt, FaRobot } from "react-icons/fa";

import Layout from "../templates/Layout";
import CustomButton from "../Button/CustomButton";
import { hasWarningStatus, isNotCharging } from "../../helpers/robotHelper";
import { useListRobotQuery } from "hooks/worker/useRobot";
import { useListCleaningEventByDateQuery } from "hooks/worker/useCleaningEvent";
import { hasWarningConsumablePart } from "lib/robot";

// コンテナのスタイル
const containerStyle: React.CSSProperties = {
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  height: "100",
  margin: "0px",
};
// ボタンを含むコンテナのスタイル
const buttonContainerStyle: React.CSSProperties = {
  display: "flex",
  flexDirection: "column",
  justifyContent: "flex-start",
  alignItems: "center",
  gap: "30px",
  padding: "0px",
};

const SelectionWork = () => {
  const navigate = useNavigate();

  const { data: robots = [] } = useListRobotQuery();
  const { data: logs } = useListCleaningEventByDateQuery({});

  const onClickCleaning = () => {
    navigate(`/CleaningEvent`);
  };

  const onClickSchedule = () => {
    navigate(`/ScheduleList`);
  };

  const onClickRobotStatus = () => {
    navigate(`/RobotStatus`);
  };

  const onClickMap = () => {
    navigate(`/MapSchedule`);
  };

  return (
    <Layout title="業務選択画面" disableBack>
      <div style={containerStyle}>
        {/* ボタンを含むコンテナ */}
        <div style={buttonContainerStyle}>
          {/* ボタン1 */}
          <CustomButton onClick={onClickCleaning}>
            <TbReport size={60} /> {/* アイコンの追加 */}
            清掃結果
            {logs &&
              logs.cleaningEvents
                .filter((l) => robots.some((r) => r.robotId === l.robotId))
                .some(hasWarningStatus) && (
                <ReportProblemIcon
                  color="error"
                  style={{
                    position: "absolute",
                    top: 0,
                    right: 0,
                    margin: "0.5rem",
                    fontSize: "40px",
                  }}
                />
              )}
          </CustomButton>

          {/* ボタン2 */}
          <CustomButton onClick={onClickSchedule}>
            <GrSchedulePlay size={60} /> {/* アイコンの追加 */}
            次回清掃予定
          </CustomButton>

          {/* ボタン3 */}
          <CustomButton onClick={onClickRobotStatus}>
            <FaRobot size={60} /> {/* アイコンの追加 */}
            ロボット一覧
            {(robots.some((r) =>
              r.consumableParts.some(hasWarningConsumablePart)
            ) ||
              robots.some(isNotCharging)) && (
              <ReportProblemIcon
                color="error"
                style={{
                  position: "absolute",
                  top: 0,
                  right: 0,
                  margin: "0.5rem",
                  fontSize: "40px",
                }}
              />
            )}
          </CustomButton>

          {/* ボタン4 */}
          <CustomButton onClick={onClickMap}>
            <FaMapMarkedAlt size={60} />
            マップ一覧
          </CustomButton>
        </div>
      </div>
    </Layout>
  );
};

export default SelectionWork;
